// extracted by css-extract-rspack-plugin
module.exports =  {"root":"SectionEmpty__root___fJhAw"};